import React from "react";
import $ from 'jquery';
import moment from "moment";

import ProjectScope from "./../../projectScope/projectScope";
import * as Misc from "./../../../misc";
import ActionTypes from "./../../../actionTypes";
import Config from './../../../config';
import Analytics from './../../../analytics';


export default class UploadItem extends React.Component {
  constructor(props) {
    super(props);

    const thisDocument = this.props.document;
    const document = ProjectScope.currentDocument();
    let selected = false;
    let disabled = false;

    if (document) {
      if (thisDocument.uid === document.uid) {
        selected = true;
      } else {
        if (document.changed) {
          disabled = true;
        }
      }
    }
    this.state = {
      selected: selected,
      disabled: disabled
    };
  }

  componentDidMount() {
    $(document).on(ActionTypes.DOCUMENTS_CHANGED, this.handleDocumentChanged);
  }

  componentWillUnmount() {
    $(document).off(ActionTypes.DOCUMENTS_CHANGED, this.handleDocumentChanged);
  }

  handleDocumentChanged = (e, data) => {
    const thisDocument = this.props.document;
    const document = ProjectScope.currentDocument();
    if (!document) {
      return;
    }

    let selected = false;
    let disabled = false;

    if (thisDocument.uid === document.uid) {
      selected = true;
    } else {
      if (document.changed) {
        disabled = true;
      }
    }

    this.setState({
      selected: selected,
      disabled: disabled
    });
  };

  handleClick = (e) => {
    Analytics.sendClickEvent("document-select");
    Misc.ignoreDefault(e);
    if (this.state.disabled || this.state.selected) {
      return;
    }

    if (this.props.document.addNew) {
      this.props.document.click();
    } else {
      ProjectScope.selectDocument(this.props.document);
    }
  };

  handleRemoveClick = (e) => {
    Analytics.sendClickEvent("document-deleted");
    Misc.ignoreDefault(e);

    ProjectScope.deleteDocument(this.props.document);
  };

  handleDocumentDownload = (e) => {
    Analytics.sendClickEvent("document-download");
    Misc.ignoreDefault(e);
    window.location.href = this.props.document.fullUrl;
  };

  handleViewPng = (e) => {
    Analytics.sendClickEvent("document-view-png");
    Misc.ignoreDefault(e);
    this.downloadURI(this.props.document.file.dataUri, this.props.document.name);
  }

  downloadURI = (uri, name) => {
    var link = document.createElement("a");
    link.download = name;
    link.href = uri;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  render() {
    const document = this.props.document;
    let removeButtonElement = null;

    if (document.addNew) {
      return (<div className={"doc-note-item-add-note" + (this.state.disabled ? ' doc-note-item-disabled' : '') }
                   onClick={this.handleClick}>
        Add New Document</div>);
    }

    let style = {
      backgroundImage: this.state.selected
        ? 'url(/Content/views/QuickQuote-v3/images/buttons/DownloadSelected.svg)'
        : 'url(/Content/views/QuickQuote-v3/images/buttons/Download.svg)'
    };

    if(Config.kioskStandAlone) {
      style.backgroundImage = this.state.selected
        ? "url('../../images/buttons/DownloadSelected.svg')"
        : "url('../../images/buttons/Download.svg)"
    }

    let className = "doc-note-item";
    if (this.state.selected) {
      className += " doc-note-item-selected";
      if (!document.isNew && !ProjectScope.jobId) {
        removeButtonElement = (<div className="doc-note-remove-button" onClick={this.handleRemoveClick}/>);
      }
    } else if (this.state.disabled) {
      className += ' doc-note-item-disabled';
    }

    return (<div className={className} onClick={this.handleClick}>
      {document.uploaded ? (
        <div className="doc-download-icon" style={style} onClick={this.handleDocumentDownload}/>) : null}
      {_.endsWith(document.name, ".png") && !document.uploaded ? (
        <div className="doc-download-icon" style={style} onClick={this.handleViewPng} />) : null }
      <div className="doc-textbox-spacer">{document.name}</div>
      <div className="doc-textbox-spacer">{moment(document.created).format("MM-DD-YY [at] hh:mm")}</div>
      {removeButtonElement}
    </div>);
  }
};



// WEBPACK FOOTER //
// ./src/components/common/notesUpload/uploadItem.js